import {callApi} from '@/api/apibase'

export const getOrderStatus = function (orderIdentifier) {
    return callApi(
        'GET',
        `/api/external/greencourse/GetOrderStatusByOrderIdentifier/${orderIdentifier}`,
    )
}
